// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"fc3874d5","135":"2f730d2d","151":"a59e2697","422":"b09075e3","453":"6386092c","687":"7113e39c","817":"8a5ccace","825":"e0ebd2dd","857":"1a6848c8","889":"b3e070f6","901":"3bc353d0"}[chunkId] + ".chunk.js";
};